<div class="container 404-tpl content-container">
	<div class="row">
		<div class="main-content col">
			<p>{{ 'Alert.Opps_something_went_wrong' | translate }}</p>
			<!--<img src="../../../../assets/images/404.jpeg" alt="404">-->
		</div>
	</div>
</div>
